<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col align-h="center" cols="12" md="4" lg="3">
                        <app-form-select-input placeholder="Estructura" :options="accessPoints" v-model="filters.structure"></app-form-select-input>
                    </b-col>
                    <b-col cols="12" md="4" lg="3">
                        <app-form-text-input placeholder="Encuestado" 
                            v-model="filters.answered_by">
                        </app-form-text-input>
                    </b-col>
                    <b-col cols="6" md="4" lg="2">
                        <app-date-time-picker id="from" placeholder="Desde" v-model="filters.from" :with-time="false"></app-date-time-picker>
                    </b-col>
                    <b-col cols="6" md="4" lg="2">
                        <app-date-time-picker id="to" placeholder="Hasta" v-model="filters.to" :with-time="false"></app-date-time-picker>
                    </b-col>
                    <b-col cols="12" md="2" lg="1">
                        <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    </b-col>
                    <b-col cols="12" md="2" lg="1">
                        <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
export default {
    props: {
        accessPoints: {
            type: Array
        }
    },
    data(){
        return {
            filters: {
                answered_by: '',
                structure: '',
                from: '',
                to: ''
            }
        }
    },

    methods: {
        clearFilters(){
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    }
}
</script>

